rdefine('app/products/properties/color',['backbone','text!products/prop/color.html'],function(Backbone,template) {
    return Backbone.Ribs.View.extend({
        className:'use-flex-grow',
        bindings:{
            '.prop_color':{
                value:{
                    data:'pmodel.color',
                    events:'keyup change all'
                }
            },
            '.prop_name':{
                value:{
                    data:'pmodel.name',
                    events:'keyup change'
                }
            },
            '.little-color-box':{
                css:{
                    'background-color':'pmodel.color'
                }
            }
        },
        events:{
            "click .little-color-box":"goToFocus"
        },
        pmodel:null,
        initialize:function(options) {
            this.cform = options.cform;
            this.pmodel = new Backbone.Ribs.Model({
                color:'#CCCCCC',
                name:''
            });
            this.pmodel.set(this.cform.get('property_'+this.model.get("id")));
            this.cform.on('change:property_'+this.model.get("id"),_.bind(function() {
                this.pmodel.set(this.cform.get('property_'+this.model.get("id")));
            },this));
            this.pmodel.on("change",_.bind(function() {
                this.cform.set('property_'+this.model.get("id"),this.pmodel.attributes);
                console.log("set test",this.pmodel.attributes);
            },this));
            this.$el.append(Template7.compile(template)());
            var $cel = this.$el.find(".prop_color");
            this.$el.find('.dropdown-menu').farbtastic(function(color) {
                $cel.css("background-color",color).val(color).trigger("change");
            });
        },
        goToFocus:function() {
            this.$el.find(".prop_color").focus().trigger("click");
            return false;
        }
    });
});